























import Vue from "vue";
import {Component, Watch, Emit} from "vue-property-decorator";
import {translate} from "../../services/translation/translation";
import './nominee-categories.less';
import {
    getNomineeAllCategoryData,
    getNomineeCategoryData,
    getNomineeItems
} from "@/services/getNomineeData/getNomineeData";


@Component({
    components: {}
})
export default class nomineeCategories extends Vue {
    private categoriesData: { id: number, image: string, title: string, url: string }[] = [];
    private nomineeItems :any[] = [];

    mounted() {
        this.categoriesData = getNomineeAllCategoryData();
        this.nomineeItems = getNomineeItems();
    }

    trans(key) {
        return translate(key);
    }

    getIsEnabledCategory(catId){
        if(this.nomineeItems[catId].length > 0){
            return true;
        }else{
            return false;
        }
    }

    selectCategory(categoryId) {
        this.onSelectCategory(categoryId);
        history.pushState('', '', this.categoriesData[categoryId].url);
    }

    @Emit("selectCategory")
    onSelectCategory(categoryId) {
    }
}
